import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from './core/auth.service';
import { NotificationService } from './core/notification.service';
import { SessionActivityService } from './core/session-activity.service';
import { SocketService } from './core/socket.service';
import { ThemeService } from './shared/theme.service';

const SUPPORTED_LANGUAGES = ['en', 'fr'];

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  private authService = inject(AuthService);
  private notificationService = inject(NotificationService);
  private sessionActivityService = inject(SessionActivityService);
  private socketService = inject(SocketService);
  private theme = inject(ThemeService);
  private translateService = inject(TranslateService);

  constructor() {
    this.translateService.use('en');
    this.sessionActivityService.initialize();

    this.authService.currentUser$.subscribe((user) => {
      const lang = user?.preferredLanguage;
      if (lang && SUPPORTED_LANGUAGES.includes(lang)) {
        this.translateService.use(lang);
      }
    });

    this.authService.token$.subscribe((token) => {
      if (token) {
        this.socketService.connect();
        this.notificationService.start(token);
        return;
      }

      this.notificationService.stop();
      this.socketService.disconnect();
    });
  }
}
